<template>
    <!-- 学校使用产品详情 -->
    <Row :gutter="10" class="school-mian">
        <div style="font-size:14px;font-weight: 800;">学校使用产品详情 (可点击数据查看更多)</div>
        <!-- 月份选择器 -->
        <Row class="month-selected">
            <Col :xs="10" :sm="10" :md="8" :lg="4" :xl="6" style="float: right;margin-top: -20px;">请选择月份:
                <Select
                    v-model="month"
                    placeholder="请选择月份"
                    @on-change="search"
                    style="width: 140px;margin-left: 10px;"
                >
                    <Option
                        v-for="item in monthList"
                        :value="item.month_name_num"
                        :key="item.month_name_num"
                    >{{ item.month_name_num }}
                    </Option>
                </Select>
            </Col>
        </Row>
        <!--点击查看更多-->
        <div class="look_more_data" v-on:click="lookMoreData">
            <Icon type="ios-loop-strong"></Icon>
            查看更多
        </div>
        <!-- 表格-->
        <Row>
            <Row :gutter="10" class="ive-pro-table">
                <div style="border: 1px solid #e8eaec;display: flex;">
                    <!--班级名-->
                    <div style="z-index:500;">
                        <div class="class_use_pro_data class_table_th ive-left-fixed">班级名称</div>
                        <div style="overflow: hidden;" id="scrollNameTop" class="ive-pro-height">
                            <template v-for="(item,index) in schoolUseDetail">
                                <div class="class_use_pro_data class_table_fixed ive-left-fixed">
                                    <div style="line-height: 2;">{{item.className}}</div>
                                    <div style="line-height: 1;">{{item.version}}</div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <!--日期-->
                    <div class="ive-pro-data">
                        <div id="scrollDataTopHead" style="overflow: hidden;">
                            <template v-for="(item,index) in schoolUseDetail[0].classInfo">
                                <div class="class_use_pro_data class_table_th ive-center-poist">{{item.day}}
                                </div>
                            </template>
                        </div>
                        <div style="overflow: auto hidden;" id="scrollDataTop" class="ive-pro-height">
                            <template v-for="(item,index) in schoolUseDetail">
                                <div style="width: 100%;">
                                    <template v-for="(subItem,subIndex) in item.classInfo">
                                        <div
                                             class="class_use_pro_data class_use_data ive-center-poist"
                                             v-on:click="goProUseDetails(subItem.time,item.diskId)">
                                            {{subItem.count}}
                                        </div>
                                    </template>

                                </div>
                            </template>
                        </div>
                    </div>
                    <!--总计-->
                    <div style="z-index:500;">
                        <div style="border-left: 1px solid #e8eaec"
                             class="class_use_pro_data class_table_th ive-right-fixed">总计
                        </div>
                        <div style="overflow-y: auto;overflow-x: hidden;" id='scrollCountTop' class="ive-pro-height">
                            <template v-for="(item,index) in schoolUseDetail">
                                <div class="class_use_pro_data class_table_fixed ive-right-fixed">{{item.counts}}
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </Row>
        </Row>
    </Row>
</template>

<script>
    import {findClassUsageRate, findCalendar} from "../../../service/api.js";

    export default {
        name: "sch-use-detail",
        data () {
            return {
                schoolId: this.$route.query.schoolId, //学校ID
                schoolName: this.$route.query.schoolName, //学校ID
                dateList: [],
                columns: [],
                schoolUseDetail: [],
                monthList: [],
                month: 0,
                startTime: "",//开始时间
                endTime: "",//结束时间
                seleStartDate: "",//选择的开始时间
                seleEndDate: "",//选择的结束时间
                diskId: "",//硬盘id
            };
        },

        methods: {
            /**
             * 点击跳转更多数据
             */
            lookMoreData () {
                this.$router.push({
                    name: "schoolUseProDetails",
                    query: {
                        schoolId: this.schoolId,
                        schoolName: this.schoolName,
                        startDate: this.seleStartDate,
                        endDate: this.seleEndDate,
                        currMonth: this.month
                    }
                });
            },
            /**
             * 查询按钮点击事件
             */
            search () {
                //选择完日期后重新请求接口
                this.getClassUsageRate();
            },
            /**
             * 获取日期下拉框数据
             */
            async getCalendar () {
                let _this = this;
                await findCalendar()
                    .then(function (data) {
                        _this.monthList = data;
                        _this.month = _this.monthList[0].month_name_num;
                        //获取学校使用率
                        _this.getClassUsageRate();
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },

            /**
             * 获取学校产品使用详情
             */
            async getClassUsageRate () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startDate: _this.month
                };
                await findClassUsageRate(params)
                    .then(function (data) {
                        _this.schoolUseDetail = data;
                        for (let i = 0; i < _this.schoolUseDetail.length; i++) {
                            _this.schoolUseDetail[i].className = _this.schoolUseDetail[i].className.length > 11 ?
                                _this.schoolUseDetail[i].className.substring(0, 11) + '..' :
                                _this.schoolUseDetail[i].className;
                        }
                        _this.$nextTick(() => {
                            document.getElementById('scrollCountTop').onscroll = function () {
                                let scrollTop = document.getElementById('scrollCountTop').scrollTop;
                                document.getElementById("scrollNameTop").scrollTop = scrollTop;
                                document.getElementById("scrollDataTop").scrollTop = scrollTop;
                            };

                            document.getElementById('scrollDataTop').onscroll = function () {
                                let scrollLeft = document.getElementById('scrollDataTop').scrollLeft;
                                document.getElementById("scrollDataTopHead").scrollLeft = scrollLeft;
                            };

                        });

                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 记住主页面选择的时间
             */
            remTime (startDate, endDate) {
                this.seleStartDate = startDate;
                this.seleEndDate = endDate;
            },
            /**
             * 进入各班级使用产品详情页面
             */
            goProUseDetails (time, diskId) {
                this.$router.push({
                    name: "schUseProDetails",
                    query: {
                        schoolId: this.schoolId,
                        schoolName: this.schoolName,
                        startTime: time,
                        endTime: time,
                        seleStartDate: this.seleStartDate,
                        seleEndDate: this.seleEndDate,
                        diskId: diskId
                    }
                });
            }
        },
        mounted () {
            this.$nextTick(() => {
                this.getCalendar();

            });
        }
    };
</script>
<style lang="scss" scoped>
    @import "../../../style/dataDetails.scss";

    .class_use_data:hover {
        background-color: #39c6e9;
        color: #fff;
        cursor: pointer;
    }

    .class_use_pro_data {
        height: 50px;
        text-align: center;
        border-bottom: 1px solid #e8eaec;
        border-right: 1px solid #e8eaec;
        line-height: 50px;
    }

    .month-selected {
        .ivu-col-span-xl-6 {
            padding-left: 190px;
        }
    }

    .class_table_th {
        background-color: #f8f8f9;
    }

    .class_table_fixed {
        background-color: #39c6e9;
        color: #fff;
    }

</style>
<style lang="scss">
    .school-mian {

        .ivu-col-span-xl-6 {
            display: block;
            width: 33%;
        }
    }
</style>
